import * as resource from './resource';

const resourceMap = {
  CASH_MY: resource.CASH_MY_OPTIONS,
  DANA_VA: resource.DANA_BANK_OPTIONS,
  DOKU_VA: resource.DOKU_BANK_OPTIONS,
  Internet_Banking_MY: resource.INTERNET_BANKING_MY_OPTIONS,
  BANKTRANSFER_PL: resource.BANKTRANSFER_PL_OPTIONS,
  MOBILE_BANKING: resource.MOBILE_BANKING_OPTIONS,
  // FPX: resource.FPX_OPTIONS, // 暂时不支持FPX，后续需求调试
};
/**
 * 需要特殊银行选择的卡种
 */
export const BankCardNames = Object.keys(resourceMap);

/**
 * 获取银行选项
 * @param {string} cardName 卡种
 * @returns {Array} 银行选项
 */
export const getBankOptions = (cardName) => {
  return resourceMap[cardName] || [];
};

export * from './resource';
